import {Row, Col, Progress} from "reactstrap";
import {formatIso8601DateTime, humanizeDuration, titleCase} from "../../utils/functions";

const SearchItem = (props: any) => {
  if (props === undefined || !props.Cpu) {
    return <></>;
  }

  const max: number = Math.round((props.MaxFps / props.scaleFactor) * 100);
  const avg: number = Math.round((props.AvgFps / props.scaleFactor) * 100);
  const pc1: number = Math.round((props.Pc1Fps / props.scaleFactor) * 100);

  const crowdedness: number = Math.round(props.Crowdedness * 100);

  return (
    <>
      <Row className="progress-benchmark-row">
        <Col md="1" className="text-center">
          <div className="number-circle">
            <span>{props.rank}</span>
          </div>
        </Col>
        <Col md="3">
          <h5 className="benchmark-item">
            {props.Cpu}
            <br />
            {props.Gpu}
          </h5>
          <p className="benchmark-search-item-subtext">
            {props.Platform} Client: {props.GameClientVersion}, Date:{" "}
            {formatIso8601DateTime(props.UpdatedAt, props.timezoneOffsetMinutes)}
            <br />
            Duration: {humanizeDuration(props.Duration)}, Crowdedness: {crowdedness}%
          </p>
        </Col>
        <Col md="2">
          <h5 className="benchmark-item">
            <>
              {props.WorldName}
              <br />
              {titleCase(props.Profile)} + {props.Resolution}
            </>
          </h5>
        </Col>
        <Col md="6">
          <div className="bar-wrap">
            <div className="bar-label">Max FPS</div>
            <Progress className="progress-benchmark" color="success" value={max}>
              {props.MaxFps}
            </Progress>
          </div>
          <div className="bar-wrap">
            <div className="bar-label">Avg FPS</div>
            <Progress className="progress-benchmark" color="info" value={avg}>
              {props.AvgFps}
            </Progress>
          </div>
          <div className="bar-wrap">
            <div className="bar-label">
              P<sub>1</sub> FPS
            </div>
            <Progress className="progress-benchmark" color="warning" value={pc1}>
              {props.Pc1Fps}
            </Progress>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SearchItem;
